import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useSelector } from "react-redux/es/exports";
import {useNavigate} from "react-router-dom";
import DashboardNavbar from "../components/layouts/dashboardNav";
import UserNavbar from "../components/layouts/userNavbar";
function UserScreen(){
    const userFromRedux = useSelector((a)=>a.user)
    const navigate = useNavigate();
    useEffect(()=>{
        if(userFromRedux){
                
        }else{
            navigate("/login")
        }
    },[])

    const Booking =()=>{
        navigate("/bookingScreen")
    }
    return(
        <>
         <DashboardNavbar/> 
        {/* <UserNavbar /> */}
        <Box >
                    <div class="album py-5 bg-dark" >
    <div class="container">
        <Typography variant="h2" sx={{color:"white",padding:"20px"}}>Book your hotel</Typography>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img width="100%" src="https://images.unsplash.com/photo-1455587734955-081b22074882?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" />
            <div class="card-body">
              <p class="card-text">
                <Typography variant="h4">ABC HOTEL</Typography>
                <Typography variant="h5">NO.OF ROOMS : 50</Typography>
                <Typography variant="h5">PRICE PER ROOMS : 1000 Rs.</Typography>
              </p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button onClick={Booking} type="button" class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text"><Typography variant="h4">ABC HOTEL</Typography>
                <Typography variant="h5">NO.OF ROOMS : 25</Typography>
                <Typography variant="h5">PRICE PER ROOMS : 700 Rs.</Typography></p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button onClick={Booking} type="button" class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img  src="https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text"><Typography variant="h4">ABC HOTEL</Typography>
                <Typography variant="h5">NO.OF ROOMS : 50</Typography>
                <Typography variant="h5">PRICE PER ROOMS : 1000 Rs.</Typography></p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button onClick={Booking} type="button" class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text"><Typography variant="h4">ABC HOTEL</Typography>
                <Typography variant="h5">NO.OF ROOMS : 50</Typography>
                <Typography variant="h5">PRICE PER ROOMS : 1000 Rs.</Typography></p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button onClick={Booking} type="button" class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"  alt="hotel Pic"/>
            <div class="card-body">
              <p class="card-text"><Typography variant="h4">ABC HOTEL</Typography>
                <Typography variant="h5">NO.OF ROOMS : 50</Typography>
                <Typography variant="h5">PRICE PER ROOMS : 1000 Rs.</Typography></p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button onClick={Booking} type="button" class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt="hotel Pic" />
            <div class="card-body">
              <p class="card-text">
              <Typography variant="h4">ABC HOTEL</Typography>
                <Typography variant="h5">NO.OF ROOMS : 50</Typography>
                <Typography variant="h5">PRICE PER ROOMS : 1000 Rs.</Typography>
              </p>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <button onClick={Booking} type="button" class="btn btn-sm btn-outline-secondary">Booking</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary">Detail</button>
                </div>
                <small class="text-muted">9 mins</small>
              </div>
            </div>
          </div>
        </div>     
      </div>
    </div>
  </div>
                </Box>
        </>
    )
}




export default UserScreen;